import mergeOperations from "@/util/shallowMerge"
import {
  useMutation 
} from "@apollo/client"
import {
  useCallback, useMemo, useRef, useState 
} from "react"
import DEFAULT_OPERATIONS from "./militaryDiscounts.gql"

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  const {
    afterSubmit, uploadRef 
  } = props
  const operations = mergeOperations(DEFAULT_OPERATIONS, props.operations)

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  const {
    addMilitaryDiscountMutation 
  } = operations

  const formApiRef = useRef(null)

  const [isLoading, setIsLoading] = useState(false)

  const [addMilitaryDiscount, {
    data, error: addMilitaryDiscountError 
  }] =
        useMutation(addMilitaryDiscountMutation, {
          fetchPolicy: "no-cache",
        })

  const handleSubmit = useCallback(
    async (formState) => {
      const {
        firstname, lastname, email 
      } = formState.values

      setIsLoading(true)

      try {
        const {
          fileList, setFileList 
        } = uploadRef.current

        const images = await Promise.all(fileList.map((file) => getBase64(file.originFileObj)));


        // let image

        // if (fileList.length) {
        //   image = fileList[0].thumbUrl
        // }

        await addMilitaryDiscount({
          variables: {
            firstname,
            lastname,
            email,
            image: images[0],
            type_id: 2,
          },
        })

        formApiRef.current?.reset()

        setFileList([])

        if (afterSubmit) {
          afterSubmit()
        }
      } catch (error) {
        if (process.env.NODE_ENV !== "production") {
          console.error(error)
        }
      } finally {
        setIsLoading(false)
      }
    },
    [addMilitaryDiscount, afterSubmit, uploadRef]
  )

  const errors = useMemo(
    () => new Map([["addMilitaryDiscountError", addMilitaryDiscountError]]),
    [addMilitaryDiscountError]
  )

  return {
    formApiRef,
    isLoading,
    errors,
    handleSubmit,
    response: data && data.addDiscountInfo,
  }
}
